import React from 'react'
import { Loader } from '@web/walter-ui-kit'
import cn from 'classnames'

import styles from './style.module.css'

interface Props {
    isSelected?: boolean
}

function Row({ isSelected }: Props) {
    return (
        <div className={cn(styles.row, isSelected && styles.selected)}>
            <div className={styles.container}>
                <Loader width="25%" height={18} />
                <div className={styles.description}>
                    <Loader width="75%" height={15} />
                </div>
            </div>
            {isSelected && (
                <div>
                    <Loader width={18} height={18} isCircled />
                </div>
            )}
        </div>
    )
}

export default Row
